<template>
  <PlaceholderPantalla
    titulo="Salidas de Inventario"
    subtitulo="Registro de consumo y mermas de inventario"
    descripcion="Controla todas las salidas de inventario, ya sea por consumo en producción, mermas, desperdicios, o ajustes. Las salidas automáticas se generan al registrar ventas, pero también puedes hacer salidas manuales por otros motivos (degustaciones, donaciones, etc.)."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Registrar salidas manuales de inventario',
  'Salidas automáticas al registrar ventas (según recetas)',
  'Clasificar tipo de salida: Consumo, Merma, Desperdicio, Donación, etc.',
  'Seleccionar productos y cantidades',
  'Actualización automática de stock',
  'Registrar motivo de la salida',
  'Control de mermas con análisis de causas',
  'Autorización de salidas (según permisos)',
  'Rastreabilidad: saber de qué lote salió cada producto',
  'Vincular salidas con órdenes de producción',
  'Calcular costo de las salidas',
  'Reportes de mermas y desperdicios',
  'Gráficas de tendencias de mermas',
  'Alertas de mermas excesivas',
  'Exportar historial de salidas'
]

const datosManejados = [
  'Fecha y hora de la salida',
  'Tipo de salida (Consumo, Merma, Desperdicio, Donación, Ajuste)',
  'Lista de productos/materias primas',
  'Cantidad por producto',
  'Unidad de medida',
  'Costo unitario',
  'Costo total de la salida',
  'Lote del que se tomó',
  'Motivo de la salida',
  'Responsable de la salida',
  'Orden de producción relacionada (si aplica)',
  'Venta relacionada (si aplica)',
  'Requiere autorización (sí/no)',
  'Estado de autorización',
  'Notas y observaciones',
  'Usuario que registró'
]
</script>
